import httpClient from '@/http-client'

export const leaveType = (Options = {}) => {
  return httpClient
    .get('/api/report/leave-summarys/leave-types', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const previewPdf = data => {
  return httpClient
    .get('/api/report/leave-summarys/preview-pdf', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const exportExcel = attributes => {
  return httpClient
    .post('/api/report/leave-summarys/export-excel', attributes, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export default { leaveType, previewPdf, exportExcel }
